var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseIndex"},[_c('MdBaseBarVue',{staticClass:"MD"}),_c('SearchBar',{staticClass:"PC"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }